import { Text, View } from '@react-pdf/renderer'
import PDFPage from '@/components/ReportPDF/PDFPage'
import PDFParagraph from '@/components/ReportPDF/PDFParagraph'
import PDFDivider from '@/components/ReportPDF/PDFDivider'
import { parseDateToTaiwanDateSlash } from '../../TaiwanDateConvert'

const Chapter5Page = ({ reportData, setPage }) => {
  const { reprotDao, phishCampaignReport } = reportData || {}
  const { companyName, campaignStartDate, campaignEndDate } = reprotDao || {}

  const {
    userCount = 0,
    fileCount = 0,
    linkCount = 0,
    openCount = 0,
    textCount = 0,
    openPercent = 0,
    linkPercent = 0,
    filePercent = 0,
    textPercent = 0,
  } = phishCampaignReport || {}

  const formattedData = {
    userCount,
    fileCount,
    linkCount,
    openCount,
    textCount,
    openPercent: openPercent.toFixed(2),
    linkPercent: linkPercent.toFixed(2),
    filePercent: filePercent.toFixed(2),
    textPercent: textPercent.toFixed(2),
  }

  return (
    <PDFPage title="第五章 結論" reportData={reportData}>
      <View
        style={{
          width: '100%',
          height: 5, // 設置分隔線的高度
          backgroundColor: 'black', // 設置顏色為黑色
          marginBottom: 30,
        }}
      >
        <PDFDivider style={{ width: '100%' }} />
      </View>
      <View>
        <Text
          style={{
            marginTop: 20,
          }}
          render={({ pageNumber }) => {
            setPage({ chap5: pageNumber })
          }}
        />
        <PDFParagraph>
          {'    '}本報告之內容為完整的社交工程郵件演練服務報告，作為
          <Text>{companyName}</Text>
          之社交工程資訊安全評估使用，測試時程為
          <Text style={{ fontWeight: 'bold', textDecoration: 'underline' }}>
            {parseDateToTaiwanDateSlash(campaignStartDate)} 至{' '}
            {parseDateToTaiwanDateSlash(campaignEndDate)}
          </Text>
          為防止惡意郵件攻擊，請依照本專案測試所給予之分析報告，針對特定單位及對象再次舉行教育訓練之宣導。
        </PDFParagraph>

        <PDFParagraph>
          {'    '}本次受
          <Text>
            測對象共
            <Text style={{ fontWeight: 'bold' }}>{formattedData.userCount || 0}</Text>
            人，瀏覽測試郵件之人數為
            <Text style={{ fontWeight: 'bold' }}>{formattedData.openCount || 0}</Text>
            人，占總受測人數的
            <Text style={{ fontWeight: 'bold' }}>{formattedData.openPercent}</Text>
            %；點閱測試連結之人數為
            <Text style={{ fontWeight: 'bold' }}>{formattedData.linkCount}</Text>
            人，占總受測人數的
            <Text style={{ fontWeight: 'bold' }}>{formattedData.linkPercent}</Text>
            %；開啟測試附件之人數為
            <Text style={{ fontWeight: 'bold' }}>{formattedData.fileCount}</Text>
            人，占總受測人數的
            <Text style={{ fontWeight: 'bold' }}>{formattedData.filePercent}</Text>
            %；輸入資料之人數為
            <Text style={{ fontWeight: 'bold' }}>{formattedData.textCount || 0}</Text>
            人，占總受測人數的
            <Text style={{ fontWeight: 'bold' }}>{formattedData.textPercent}</Text>
            %。多數受測者具有相當警覺性，未開啟社交檢測信件，但仍有受測者未詳察寄件來源或身份，建議可針對此類受測者進行教育訓練，藉此訓練受測者自身資安意識的強化。
          </Text>
        </PDFParagraph>

        <PDFParagraph>
          {'    '}針對此次檢測，
          <Text>{companyName}</Text>
          受測者均有相當程度之資安意識，但資訊安全之宣導及教育仍然必須持續進行，才能促使組織成員養成良好的電子郵件使用習慣。此外，亦可針對警覺性較低的受測對象(如開啟信件比率最高的某處室或某先生/小姐)，規劃二次教育訓練，加強相關防護觀念的宣導，並著重攻擊實例說明，並應按其資安等級，定期舉辦教育訓練。相關技術和規劃方式歡迎諮詢台灣固網的專業人員。
        </PDFParagraph>

        <PDFParagraph>
          {'    '}
          由於資訊安全相關產業的發展非常迅速，而且社交工程攻擊總是不斷地被發現，定期舉行教育訓練與社交工程演練才能使組織安全防護達到內外相護的最佳效果，這也絕對是保障組織內部資訊安全的必要步驟。
        </PDFParagraph>
      </View>
    </PDFPage>
  )
}

export default Chapter5Page
